import { useEffect, useState } from 'react';
import { catalogAssetCacheKey, resolveCatalogAsset, subscribeCatalogAssetInvalidation } from '../api/assets';
import { normalizedArtworkThumbnail } from '../editor/image';

export function ArtworkThumbnail({ src, alt = '', className, safeMargin = .07 }: { src: string; alt?: string; className?: string; safeMargin?: number }) {
  const [normalized, setNormalized] = useState('');
  const [failed, setFailed] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => subscribeCatalogAssetInvalidation((cacheKey) => {
    if (cacheKey === catalogAssetCacheKey(src)) setRevision((current) => current + 1);
  }), [src]);
  useEffect(() => {
    let current = true;
    setNormalized('');
    setFailed(false);
    void normalizedArtworkThumbnail(src, 320, safeMargin)
      .then((url) => { if (current) setNormalized(url); })
      .catch(async () => {
        try {
          const url = await resolveCatalogAsset(src);
          if (current) { setFailed(true); setNormalized(url); }
        } catch { if (current) setFailed(true); }
      });
    return () => { current = false; };
  }, [revision, safeMargin, src]);
  return <span className={`artwork-thumbnail ${normalized ? 'is-ready' : 'is-loading'}${failed ? ' is-failed' : ''}${className ? ` ${className}` : ''}`}>
    {normalized ? <img className="artwork-thumbnail__image" src={normalized} alt={alt} loading="lazy" /> : <span className="artwork-thumbnail__skeleton" aria-hidden="true" />}
  </span>;
}
